import { Link } from "react-router-dom";
import { FCX } from "@datassential/platform-ui-lib";
import { routeNames } from "@core/routeNames";
import { DocumentTypes } from "@pages/NewDocuments/DocumentView/DocumentView.helpers";

// Table renders rows through this component, spreading the row props (className, style, children) onto the link.
const MacsListRowLink: FCX<{ macId?: number }> = ({ macId, ...props }) => (
    /* @ts-ignore -- react-router's Link is typed against a second @types/react copy (same as MacsListObsolete RowLink) */
    <Link
        {...props}
        to={{ pathname: routeNames.viewDocument, search: `?id=${macId}&doctype=${DocumentTypes.mac}` }}
    />
);

export default MacsListRowLink;
